import { ListAltOutlined, OpenInNew } from "@mui/icons-material";
import { ListItem, IconButton, Tooltip } from "@mui/material";
import { useContext, useState } from "react";

import DataContext from "../../context/DataContext";
import { useHistoryNavigate } from "../../hooks/useHistoryNavigate";
import ProviderDetail from "../modules/providers/provider-detail";

export default function ClientListItemProCli({ client, index, currentPage }) {
  const { userType, setSelectedClient } = useContext(DataContext);
  const [detailModal, setDetailModal] = useState(false);
  const { historyNavigate } = useHistoryNavigate();

  const resultClasses =
    "text-sm border-gray-100 sm:border-r sm:last-of-type:border-0 sm:p-2 px-2 py-2 sm:border-b-0";
  const columnClasses = userType !== "Law Firm" ? "md:w-1/5 w-1/3" : "md:w-1/4 w-1/3";

  const truncate = (str, max, len) => {
    if (!str) {
      return;
    }
    return str.length > max ? str.substring(0, len) + "..." : str;
  };

  const navigateToDetail = (client) => {
    setSelectedClient(client.case.pk);
    historyNavigate("client-detail", client.case.pk);
  };

  return (
    <ListItem key={index} value={client} className="items-center px-2 py-0 pt-0 md:px-4">
      <div
        className={
          "my-1 flex w-full justify-evenly rounded-md border-y border-gray-100 bg-white py-1 text-black shadow-lg"
        }
      >
        <div className={`block w-1/3 pl-2 text-left md:w-[20%] ${resultClasses}`}>
          {currentPage > 1 ? index + 1 * ((currentPage - 1) * 25) + 1 : index + 1}
          .&nbsp;
          <Tooltip title={client?.client?.name}>
            <>{truncate(client?.client?.name || "", 11, 15)}&nbsp;</>
          </Tooltip>
          <IconButton onClick={() => navigateToDetail(client)}>
            <OpenInNew />
          </IconButton>
        </div>
        <div className={`block w-1/3 pl-2 text-center md:w-[15%] ${resultClasses} hidden md:block`}>
          {!client
            ? ""
            : new Date(client.createdAt).toLocaleDateString("en-US", {
                timeZone: "UTC",
              })}
        </div>
        <div className={`block ${columnClasses} pl-2 text-center ${resultClasses}`}>
          {client?.case?.status || ""}
        </div>
        <div
          className={`block w-1/3 pl-2 text-center md:w-[25%] ${resultClasses} ${
            userType !== "Law Firm" ? "border-none" : ""
          }`}
        >
          <Tooltip title={client?.provider?.name || ""}>
            <>{truncate(client?.provider?.name || "", 14, 20)} </>
          </Tooltip>
          <IconButton onClick={() => setDetailModal(true)} className="text-purple-600">
            <ListAltOutlined />
          </IconButton>
        </div>
        {userType !== "Law Firm" && (
          <div className={`w-1/5 pl-2 text-center md:block ${resultClasses} border-none`}>
            {client?.case?.lawFirmName || ""}
          </div>
        )}
      </div>
      {detailModal && <ProviderDetail providerDetail={client.provider} open setOpen={setDetailModal} />}
    </ListItem>
  );
}
